import { useEffect, useState } from 'react';
import { getTruckFuelEconomy, type TruckFuelEconomy } from '../trucks.api';

export type TruckFuelEconomyState = { status: 'loading' } | { status: 'loaded'; economy: TruckFuelEconomy } | { status: 'error' };

/** The truck's rolling consumption for the details tab. A failed read only hides the card's figure: the rest of the record still works. */
export function useTruckFuelEconomy(truckId: string): TruckFuelEconomyState {
  const [result, setResult] = useState<{ truckId: string; state: TruckFuelEconomyState } | null>(null);

  useEffect(() => {
    let cancelled = false;
    getTruckFuelEconomy(truckId)
      .then((economy) => {
        if (!cancelled) setResult({ truckId, state: { status: 'loaded', economy } });
      })
      .catch(() => {
        if (!cancelled) setResult({ truckId, state: { status: 'error' } });
      });
    return () => {
      cancelled = true;
    };
  }, [truckId]);

  // A result for another truck is stale: show the skeleton until this truck's own arrives.
  return result?.truckId === truckId ? result.state : { status: 'loading' };
}
